// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + (chunkId === 9765 ? "crm" : chunkId) + "." + {"8656":"c86b7fc8","9585":"3b53517f","9765":"8f4b75de"}[chunkId] + ".chunk.css");